/* Free gift at 3 items.

   When the cart holds 3 or more paid items, exactly one "Free Gift – Spiral
   Multicolor Cable Protectors" line (a separate ₹0 product, so it is free in
   any checkout, including Shiprocket) is kept in the cart, locked at quantity 1.
   Below 3 paid items it is removed. The gift line carries the hidden
   "_Auto Gift" property, which cart-drawer.liquid uses to render it locked
   (no quantity input / remove button); smart-cart-progress.liquid locks it on
   the /cart page.

   Legacy: the previous version added the regular ₹149 Cable Protectors
   (variant 51443369017623) with "_Auto Gift" for every 3 clearance items, and
   customers were charged for it. Any such line is removed here. A Cable
   Protector the customer added themselves (no "_Auto Gift") is left alone.

   Exposes window.CaseCrushGiftSync(), returning a promise that settles once the
   cart is in sync, so Buy Now can wait for it before opening the checkout. */
(function () {
  'use strict';
  if (window.__ccGiftSyncInit) return;
  window.__ccGiftSyncInit = true;

  var GIFT_VARIANT_ID = 55327721816343;
  var GIFT_PROPERTY_KEY = '_Auto Gift';
  var GIFT_THRESHOLD = 3;
  var SELF_SOURCE = 'clearance-gift-sync';
  var chain = Promise.resolve();
  var debounceTimer = null;

  function isAutoGiftProperty(item) {
    return !!(item.properties && item.properties[GIFT_PROPERTY_KEY]);
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed: ' + url);
      return response.json();
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed: /cart.js');
      return response.json();
    });
  }

  function publishCartUpdate(cartData) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: SELF_SOURCE, cartData: cartData });
    }
  }

  // The header cart count isn't part of the drawer re-render, so refresh it the
  // same way Dawn does after its own cart changes.
  function refreshCartBubble() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return null;
    return fetch('/?sections=cart-icon-bubble')
      .then(function (response) {
        if (!response.ok) throw new Error('Section request failed: cart-icon-bubble');
        return response.json();
      })
      .then(function (sections) {
        var html = sections && sections['cart-icon-bubble'];
        if (!html) return;
        var section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (section) bubble.innerHTML = section.innerHTML;
      });
  }

  function doSync() {
    return getCart().then(function (cart) {
      var paidQty = 0;
      var giftLines = [];
      var updates = {};
      var needsUpdate = false;

      cart.items.forEach(function (item) {
        if (item.variant_id === GIFT_VARIANT_ID) {
          giftLines.push(item);
        } else if (isAutoGiftProperty(item)) {
          updates[item.key] = 0;
          needsUpdate = true;
        } else {
          paidQty += item.quantity;
        }
      });

      var wantGift = paidQty >= GIFT_THRESHOLD;
      var keep = null;
      if (wantGift) {
        giftLines.forEach(function (item) {
          if (!keep && isAutoGiftProperty(item)) keep = item;
        });
        if (!keep && giftLines.length) keep = giftLines[0];
      }

      giftLines.forEach(function (item) {
        var target = item === keep ? 1 : 0;
        if (item.quantity !== target) {
          updates[item.key] = target;
          needsUpdate = true;
        }
      });

      var needsAdd = wantGift && !keep;
      if (!needsUpdate && !needsAdd) return null;

      var step = needsUpdate ? postJson('/cart/update.js', { updates: updates }) : Promise.resolve();
      return step
        .then(function () {
          if (!needsAdd) return null;
          var properties = {};
          properties[GIFT_PROPERTY_KEY] = 'yes';
          return postJson('/cart/add.js', { items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: properties }] });
        })
        .then(getCart)
        .then(function (freshCart) {
          publishCartUpdate(freshCart);
          return refreshCartBubble();
        });
    });
  }

  // Runs one sync at a time, in order. Never rejects.
  function syncNow() {
    chain = chain.then(doSync).catch(function () {});
    return chain;
  }

  function scheduleSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncNow, 400);
  }

  window.CaseCrushGiftSync = syncNow;

  function observe(selector) {
    var target = document.querySelector(selector);
    if (target && window.MutationObserver) {
      new MutationObserver(scheduleSync).observe(target, { childList: true, subtree: true });
    }
  }

  function init() {
    scheduleSync();
    observe('cart-drawer');
    observe('#main-cart-items');

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === SELF_SOURCE) return;
        scheduleSync();
      });
    }

    // Back/forward cache restores and returning to the tab can bring a stale cart.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) scheduleSync();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') scheduleSync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
